{
  "llama-3.1-8b-instant": {
    "modelName": "llama-3.1-8b-instant",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.05,
            "outputPricePerMillion": 0.08
          }
        }
      }
    ]
  },
  "llama-3.3-70b-versatile": {
    "modelName": "llama-3.3-70b-versatile",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.59,
            "outputPricePerMillion": 0.79
          }
        }
      }
    ]
  },
  "openai/gpt-oss-20b": {
    "modelName": "openai/gpt-oss-20b",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.075,
            "outputPricePerMillion": 0.3
          }
        }
      }
    ]
  },
  "openai/gpt-oss-120b": {
    "modelName": "openai/gpt-oss-120b",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.15,
            "outputPricePerMillion": 0.6
          }
        }
      }
    ]
  },
  "openai/gpt-oss-safeguard-20b": {
    "modelName": "openai/gpt-oss-safeguard-20b",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.075,
            "outputPricePerMillion": 0.3
          }
        }
      }
    ]
  },
  "qwen/qwen3.6-27b": {
    "modelName": "qwen/qwen3.6-27b",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.6,
            "outputPricePerMillion": 3.0
          }
        }
      }
    ]
  },
  "meta-llama/llama-prompt-guard-2-86m": {
    "modelName": "meta-llama/llama-prompt-guard-2-86m",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.04,
            "outputPricePerMillion": 0.04
          }
        }
      }
    ]
  },
  "meta-llama/llama-prompt-guard-2-22m": {
    "modelName": "meta-llama/llama-prompt-guard-2-22m",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.03,
            "outputPricePerMillion": 0.03
          }
        }
      }
    ]
  }
}
